module.exports = __webpack_public_path__ + "static/media/az.d1c6ff3d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/az.svg
// module id = 57
// module chunks = 0